import { DEFAULT_URL } from './pages/DiscoverPage/const';

export const JOIN_TEAM_LINK = '/my-account/join-team/';
export const JOIN_TEAM_ROUTE = `${JOIN_TEAM_LINK}:hash`;

export const SERP_ROUTES = [
  `${DEFAULT_URL}/search`,
  `${DEFAULT_URL}/videos`,
  `${DEFAULT_URL}/pathways`,
  `${DEFAULT_URL}/glossary`,
  '/pathways',
  '/videos',
];

export const INSIGHTS_SERP_ROUTE = `${DEFAULT_URL}/insights`;

export const PRICING_ROUTE = '/pricing';
export const MY_MEMBERSHIP_ROUTE = '/my-account/membership-area';
export const HOME_ROUTE = '/home';
export const ROOT_ROUTE = '/';

export const MAINTENANCE = '/maintenance';
